<template>
   <KeyArtBackground :images=images class="page-404 page survey-section-bkg">
    <div class="container">
      <Title title="page_not_found" size="large" color="lightblue" :translate=true direction="none"  />
    </div>
    <div class="container copy">
      <p>{{$t('error_404')}}</p>
      <div class="button-container">
        <AppButton class="button button-blue-rounded" type="router" route="home" cta="home" />
      </div>
    </div>
  </KeyArtBackground>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

import Title from '@/components/ui/Title'
import KeyArtBackground from '@/components/ui/KeyArtBackground';
import AppButton from '@/components/ui/AppButton';

export default {
  name: 'Page404',
  components: {
    AppButton,
    KeyArtBackground,
    Title
  },
  created() {
    this.getHomepage();
  },
  computed: {
    ...mapGetters({
      homepage: 'homepage',
    }),
    images(){
      if(this.homepage) {
        return this.homepage.intro_background_images;
      }
    }
  },
  methods: {
    ...mapActions({
      getHomepage: 'getHomepage',
    })
  }
};
</script>

<style lang="scss">
.page-404 {
  background: #333;
  padding: 50px 0;

  .button-container {
    margin-top: 30px;

    .button-blue-rounded button,
    .button-blue-rounded a {
      padding: 5px 0;

      @include bp($bp--m) {
        padding: 10px 0;
      }
    }
  }

  .container {
    position: relative;
    z-index: 3;
  }

  .copy {
    font-size: 15px;
    line-height: 24px;
    color: #fff;
    text-align: center;

    p {
      padding-bottom: 10px;

      a {
        font-weight: bold;
        color: #fff;
        text-decoration: underline;
      }

    }

    @include bp($bp--m) {
      font-size: 16px;
      line-height: 24px;
      max-width: 780px;
      margin: 50px auto 0 auto;
    }
  }

  &:before {
    width: 100%;
    height: 100%;
    content: '';
    pointer-events: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/404.vue